<template>
  <div class="h-screen m-0">
    <div class="col-12">
      <TopStepperComponent />
    </div>
    <div class="col-12 p-0">
      <slot />
    </div>
  </div>
</template>
